import React, { useEffect, useState } from "react";
import { Sparkles, ShieldCheck, ArrowRight, Power, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MaintenancePage = ({ user, onLogin, onEnter }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    fetch(`${API}/admin/maintenance`, { credentials: "include" })
      .then((r) => { if (r.ok) setIsAdmin(true); })
      .catch(() => {});
  }, []);

  const disable = async () => {
    setBusy(true);
    try {
      await fetch(`${API}/admin/maintenance`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" }, body: JSON.stringify({ enabled: false }),
      });
      window.location.reload();
    } catch { setBusy(false); }
  };

  return (
    <div className="min-h-screen relative flex flex-col items-center justify-center px-6 text-center overflow-hidden" data-testid="maintenance-page">
      <div className="ws-orb a" />
      <div className="ws-orb b" />
      <div className="relative z-10 max-w-xl mx-auto ws-fade-up">
        <div className="flex items-center justify-center mb-8">
          <span className="ws-logo-3d w-20 h-20"><img src="/wsj-logo.webp" alt="Wealth Secret Journal" /></span>
        </div>
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full mb-6 border border-[color:var(--ws-border)]" style={{ background: "rgba(56,189,248,0.08)" }}>
          <Sparkles className="w-3.5 h-3.5 text-[color:var(--ws-blue-bright)]" />
          <span className="text-[11px] tracking-[0.18em] uppercase text-[color:var(--ws-blue-bright)] font-semibold">Launching Soon</span>
        </div>
        <h1 className="ws-heading text-4xl sm:text-5xl font-extrabold text-white leading-tight">
          Wealth Secret Journal is <span className="ws-title-gradient">launching soon</span>
        </h1>
        <p className="text-base sm:text-lg text-[color:var(--ws-muted)] mt-5 leading-relaxed">
          We're putting the finishing touches on your trading command center.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3 text-[12px] text-[color:var(--ws-muted)]">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-[color:var(--ws-border)]">
            <span className="w-2 h-2 rounded-full bg-[#34d399] animate-pulse" /> Systems live · syncing trades
          </span>
        </div>

        {isAdmin ? (
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3" data-testid="maintenance-admin-controls">
            <button onClick={onEnter} data-testid="maintenance-enter-app"
              className="ws-btn-primary px-4 py-2.5 rounded-xl text-[13px] font-bold inline-flex items-center gap-2">
              Enter app <ArrowRight className="w-4 h-4" />
            </button>
            <button onClick={disable} disabled={busy} data-testid="maintenance-disable"
              className="ws-btn-ghost px-4 py-2.5 rounded-xl text-[13px] font-semibold inline-flex items-center gap-2">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Power className="w-4 h-4" />} Turn off maintenance
            </button>
          </div>
        ) : !user ? (
          <button onClick={onLogin} data-testid="maintenance-team-login"
            className="mt-10 inline-flex items-center gap-2 text-[12px] text-[color:var(--ws-muted)] hover:text-white transition-colors">
            <ShieldCheck className="w-4 h-4" /> Team sign in
          </button>
        ) : (
          <div className="mt-10 text-[12px] text-[color:var(--ws-muted)]">You'll be notified the moment we go live. 🚀</div>
        )}
      </div>
      <div className="absolute bottom-6 text-[11px] text-[color:var(--ws-muted)]">© {new Date().getFullYear()} Wealth Secret Journal · wealthsecret.in</div>
    </div>
  );
};

export default MaintenancePage;
